export enum EventType {
  IndiaBarcode = 0,
  Receipt,
  RailOrderConfirmed,
  RailTicketAssets,
}
